import { getApiErrorMessage } from "shared/utils";
import type { ApiError } from "shared/utils";
import {
  PROFILE_DEFAULT_MESSAGE,
  PROFILE_FALLBACK_MESSAGES,
} from "entities/user";

// 400 (invalid_avatar) приходит только на загрузку, на удаление — 401/404.
const FALLBACK_MESSAGES: Record<number, string> = {
  ...PROFILE_FALLBACK_MESSAGES,
  400: "This image can't be used as an avatar. Please choose another one.",
};

export const getAvatarError = (error: ApiError): string | null =>
  getApiErrorMessage(error, FALLBACK_MESSAGES, PROFILE_DEFAULT_MESSAGE);
